import { useState } from 'react'

const Mark = () => (
  <svg viewBox="0 0 48 48" aria-hidden="true">
    <path d="M24 4C17 14 10 22 10 31a14 14 0 0 0 28 0C38 22 31 14 24 4Z" />
  </svg>
)

export function Header() {
  const [open, setOpen] = useState(false)
  const close = () => setOpen(false)

  return (
    <header className="site-header" id="top">
      <div className="container nav-wrap">
        <a className="brand" href="#top" aria-label="Alshifaa Honey home">
          <Mark />
          <span><strong>ALSHIFAA</strong><small>PURE HONEY</small></span>
        </a>
        <button
          className="menu-toggle"
          type="button"
          aria-expanded={open}
          aria-controls="site-nav"
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen((value) => !value)}
        >
          <span /><span />
        </button>
        <nav id="site-nav" className={open ? 'open' : ''} aria-label="Main navigation">
          <a href="#story" onClick={close}>Our Story</a>
          <a href="#quality" onClick={close}>Why Alshifaa</a>
          <a href="#order" onClick={close}>Order</a>
        </nav>
        <a className="button button-small desktop-cta" href="#order">Order Now</a>
      </div>
    </header>
  )
}

export { Mark }
